// import styles
import "./Project.css";

// import pacchetti
import Select from "react-select";
import { useState } from "react";

const filter = [
  { value: "tutti", label: "Tutti i file" },
  { value: "pdf", label: "PDF" },
  { value: "doc", label: "Word" },
  { value: "xls", label: "Excel" },
  { value: "img", label: "Immagini" },
  { value: "altro", label: "Altri file" },
];

export default function ProjectFilter({ filtro, change, onSearch }) {
  const [searchTerm, setSearchTerm] = useState("");
  
  // Gestisce il cambio del filtro dal dropdown
  const handleFilterChange = (option) => {
    change(option.value);
  };

  // Gestisce il cambio del termine di ricerca
  const handleSearchChange = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    // Passa il termine di ricerca al componente padre
    onSearch && onSearch(term);
  };

  // Trova l'opzione corrente selezionata
  const currentOption = filter.find(option => option.value === filtro) || filter[0];

  return (
    <div className="project-files-filter">
      <div className="filters-container">
        <input
          type="text"
          onChange={handleSearchChange}
          placeholder="Cerca file"
          className="search-bar"
          value={searchTerm}
        />
        <div className="dropdown-filters">
          <Select
            className="filter-select"
            options={filter}
            onChange={handleFilterChange}
            value={currentOption}
            placeholder="Tipo di file"
            isSearchable={false}
          />
        </div>
      </div>
    </div>
  );
}